module.exports = __webpack_public_path__ + "img/info.783bb018.png";